import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import { I18nTextResource } from "common/resources/I18nText/I18nTextResource";
import { translateISO369 } from "utils/I18nText";

type IProps = {
	value: I18nTextResource[];
};

export default function DevelopmentStageTag(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Typography type="p" weight="medium" size="small" color="inherit" className={classes["label"]}>
				{I18n.asset.pages.project.production_stage}
			</Typography>
			<Typography type="p" weight="medium" size="small" color="inherit" className={classes["value"]}>
				{translateISO369(props.value)}
			</Typography>
		</div>
	);
}
